var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
export function ToolbarItem(_a) {
    var { href, handleClick, children } = _a, props = __rest(_a, ["href", "handleClick", "children"]);
    return (React.createElement("a", Object.assign({ role: "menuitem", tabIndex: 0, className: "ab-item", onClick: handleClick, onKeyDown: handleClick, href: href }, props), children));
}
